import React, {useContext} from "react";
import {useTranslation} from "react-i18next";
import {User} from "../../models/User";
import {ButtonType, UiButton} from "../ui-components/button/uiButton";
import {useNavigate} from "react-router";
import {AppContext} from "../authProvider/AuthProvider";

export enum FriendState {
    isFriends,
    isNotFriends,
    isRequestPending,
    sentYouRequest
}

type PlayerItemType = {
    user: User;
    friendState: FriendState;
    removeFriend?: (user: User) => void;
    sendFriendRequest?: (user: User) => void;
    acceptRequest?: (user: User) => void;
    declineRequest?: (user: User) => void;
}

export const PlayerItem: React.FC<PlayerItemType> = (props) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {currentUser, isConnected} = useContext(AppContext)

    function renderButton(className: string) {
        if (props.user.id === currentUser?.id || !isConnected) {
            return <></>
            
        } else if (props.friendState === FriendState.isFriends && props.removeFriend) {
            return <UiButton
                className={className}
                icon="close"
                text={t("players.remove-friend")}
                onClick={() => props.removeFriend!(props.user)}
            />
            
        } else if (props.friendState === FriendState.sentYouRequest && props.acceptRequest && props.declineRequest) {
            return <div className="flex gap-2 max-lg:w-full">
                <UiButton
                    className={`${className} max-lg:w-1/2`}
                    icon="check"
                    iconClassName="h-6"
                    text={t("global.accept")}
                    onClick={() => props.acceptRequest!(props.user)}
                />

                <UiButton
                    className={`${className} max-lg:w-1/2`}
                    icon="close"
                    iconClassName="h-6"
                    text={t("global.decline")}
                    type={ButtonType.transparentBg}
                    onClick={() => props.declineRequest!(props.user)}
                />
            </div>
            
        } else if (props.friendState === FriendState.isRequestPending) {
            return <UiButton
                className={className}
                text={t("players.friend-request-sent")}
                type={ButtonType.disabled}
            />
            
        } else if (props.friendState === FriendState.isNotFriends && props.sendFriendRequest) {
            return <UiButton
                className={className}
                icon="add-person"
                text={t("players.send-friend-request")}
                onClick={() => props.sendFriendRequest!(props.user)}
            />
        }
    }

    return (
        <div
            key={props.user.id}
            className="player-item flex flex-col lg:flex-row gap-2 items-center justify-between bg-deep-blue p-4 rounded-3xl
               hover:bg-deep-blue-hover cursor-pointer has-[.player-item-button:hover]:bg-deep-blue"
            onClick={() => navigate(`/stats?player-id=${props.user.id}`)}
        >
            <div className="flex items-center gap-5 max-lg:w-full">
                <img
                    loading="lazy"
                    src={props.user.getPP()}
                    className={"w-24 h-24 rounded-full"}
                    alt={`${props.user.name} profile picture`}
                />

                <p className="text-wrap break-all">{props.user.name}</p>
            </div>

            {renderButton("player-item-button max-lg:w-full h-auto")}
        </div>
    )
}
